import React, { Component, Fragment, startTransition } from "react";
import {
  API_TOKEN_NAME,
  WEBSITEPAGE_URL,
  USER_ID,
  IMAGE_URL,
  SITE_URL,
  USER_LOCAL_ID,
} from "../../constants";
import { scAxiosAdmin } from "../..";
import $ from "jquery";
import logo from "../../images/newlogo.png";
import icons_rotate from "../../images/icons-rotate.png";
import hotline_phone from "../../images/hotline_phone.svg";
import PopupIndex2 from "./PopupIndex2";
import PopupIndex3 from "./PopupIndex3";
import PopupIndex4 from "./PopupIndex4";
import PopupIndex5 from "./PopupIndex5";
import PopupPatientLists from "./PopupPatientLists";
import PopupRegister from "./PopupRegister";
import "../frontend/homepage.css";
import CollapsibleButton from "../CollapsibleButton";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { MyContext } from "../MyProvider";
import PatientRegisterPopup from "./PatientRegistrationPopup";

const GetAllMenu = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/menu/getallmenu", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getDefaultSearch = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/homesetting/getdefaultsearchdata", {
      method: "get",
      headers: {
        Accept: "application/json",
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getSearchData = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/homesetting/getsearchdata", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getSingleHeaderAnnoucementData = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request(
      "/headerannoucement/getsingleheaderannoucement/" + id,
      {
        method: "get",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
      }
    );
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

class HeaderHome extends Component {
  state = {
    step: 1,
    showthirdpopup: "",
    menu: [],
    search_keywords: "",
    default_doctors: [],
    default_packages: [],
    default_publications: [],
    header_annoucement_text: "",
    header_annoucement_link: "",
    header_phone_no: "",
    patientRegPopup: false,
    showPatientRegPopup: "",
  };
  handleOpenPatientRegisterPopUp = () => {
    // $(".register_popup").addClass("show");
    // $(".register_popup").css("visibility", "visible");
    // $(".modal-backdrop.fade.show").remove();
    // $("body").css("overflow", "");
    // $("body").css("padding-right", "");

    this.setState({
      patientRegPopup: true,
      showPatientRegPopup: "offcanvas offcanvas-start show",
    });
  };
  nextStep = (e) => {
    this.setState({ step: this.state.step + 1 });
  };
  prevStep = (e) => {
    this.setState({
      step: this.state.step - 1,
      showthirdpopup: "offcanvas offcanvas-start show",
    });
  };
  refreshStaticMenu = (page) => {
    GetAllMenu(page)
      .then((res) => {
        if (res.status === true) {
          var records = res.data.data;
          this.setState({ menu: records });
        } else {
          this.setState({ menu: "" });
        }
        this.setState({ enableShdo: false });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  refreshGetDefaultSearchData = () => {
    getDefaultSearch()
      .then((res) => {
        if (res.status === true) {
          this.setState({
            default_doctors: res.doctor_data,
            default_packages: res.package_data,
            default_publications: res.publication_data,
            default_departments: res.department_data,
          });
        } else {
          this.setState({
            default_doctors: "",
            default_packages: "",
            default_publications: "",
          });
        }
      })
      .catch((err) => {});
  };
  handleKeyUp = (event) => {
    const data = {
      keywords: this.state.search_keywords,
    };
    getSearchData(data)
      .then((res) => {
        if (res.status === true) {
          this.setState({
            default_doctors: res.doctor_data,
            default_packages: res.package_data,
            default_publications: res.publication_data,
            default_departments: res.department_data,
          });
        } else {
          this.setState({
            default_doctors: "",
            default_packages: "",
            default_publications: "",
          });
        }
        this.setState({ enableShdo: false });
      })
      .catch((err) => {
        console.log(err);
      });
  };
  showSearchResult = () => {
    $(".search-popup").show();
    $("body").click(function () {
      $(".search-popup").hide();
    });
    this.refreshGetDefaultSearchData();
  };
  refreshgetSingleHeaderAnnoucementData = (id) => {
    getSingleHeaderAnnoucementData(id)
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          this.setState({
            header_annoucement_text: records.header_annoucement_text,
            header_annoucement_link: records.header_annoucement_link,
            header_phone_no: records.header_phone_no,
          });
        } else {
          this.setState({
            header_annoucement_text: "",
            header_annoucement_link: "",
            header_phone_no: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  componentDidMount() {
    let header_annoucement_id = "1";
    // this.refreshgetSingleHeaderAnnoucementData(header_annoucement_id);
    /*if(localStorage.getItem(USER_ID)){
      let login_step_number = this.state.step + 1;
      this.setState({
        step: login_step_number + 1,
        showthirdpopup: 'offcanvas offcanvas-start',
      });
    } else {
      this.setState({
        step: this.state.step,
        showthirdpopup: 'offcanvas offcanvas-start show',
      });
    }*/
    
    if (localStorage.getItem(USER_ID)) {
      let login_step_number = this.state.step + 1;
      this.setState({
        step: login_step_number,
        showthirdpopup: "offcanvas offcanvas-start",
      });
    } else {
      this.setState({
        step: this.state.step,
        showthirdpopup: "offcanvas offcanvas-start show",
      });
    }
    this.refreshStaticMenu();
  }
  render() {
    let patient_user_id = localStorage.getItem(USER_ID);
    const UserName = localStorage.getItem("patient_name");
    const cart = localStorage.getItem("totalAmount");
    // console.log(user)
    let step_html = "";
    let step = this.state.step;
    if (step === 1) {
      step_html = (
        <div className="">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-3 custom-margin 1">
                <PopupIndex4
                  nextStep={this.nextStep}
                  prevStep={this.prevStep}
                />
              </div>
            </div>
          </div>
        </div>
      );
      /*} else if (step === 2) {
          step_html = <div className="">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-3 custom-margin 2">
                  <PopupPatientLists nextStep={this.nextStep} prevStep={this.prevStep} />
                </div>
              </div>
            </div>
        </div>*/
    } else if (step === 2) {
      step_html = (
        <div className="">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-3 custom-margin 3">
                <PopupIndex2
                  nextStep={this.nextStep}
                  showpopup={this.state.showthirdpopup}
                />
              </div>
            </div>
          </div>
        </div>
      );
    } else if (step === 3) {
      step_html = (
        <div className="">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-3 custom-margin 4">
                
                <PopupIndex3
                  nextStep={this.nextStep}
                  prevStep={this.prevStep}
                />
              </div>
            </div>
          </div>
        </div>
      );
    } else if (step === 4) {
      step_html = (
        <div className="">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-3 custom-margin 5">
                <PopupIndex5 />
              </div>
            </div>
          </div>
        </div>
      );
    } else if (step === 5) {
      step_html = (
        <div className="">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-3 custom-margin 5">
                <PopupRegister />
              </div>
            </div>
          </div>
        </div>
      );
      // }
      // else if (this.state.patientRegPopup) {
      //   step_html = (
      //     <div className="">
      //       <div className="container">
      //         <div className="row">
      //           <div className="col-md-6 col-sm-3 custom-margin 5">
      //             <PopupRegister />
      //           </div>
      //         </div>
      //       </div>
      //     </div>
      //   );
    } else {
      step_html = (
        <div className="">
          <div className="container">
            <div className="row">
              <div className="col-md-6 col-sm-3 custom-margin 5">
                <PopupRegister />
              </div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div>
        {this.state.header_annoucement_text ? (
          <header className="top-part">
            <div className="container">
              <p>
                <a
                  href={this.state.header_annoucement_link}
                  target="_blank"
                  style={{ color: "#fff", textDecoration: "none" }}
                >
                  {this.state.header_annoucement_text}
                </a>
              </p>
            </div>
          </header>
        ) : (
          ""
        )}
        <div className="text-light p-2 " style={{ backgroundColor: "#187979" }}>
          <div className="container">
            <div className="row">
              <div
                className="col-md-8 top-header d-md-flex d-sm-inline d-xs-inline"
                style={{
                  display: "flex",
                  rowGap: "20px",
                  columnGap: "20px",
                  justifyContent: "flex-start",
                }}
              >
                <a
                  href="tel:10666"
                  style={{
                    color: "#ffff",
                    textDecoration: "none",
                  }}
                >
                  <i className="fa fa-phone" style={{ marginRight: "5px" }}></i>
                  10666
                </a>
                <br className="d-lg-none" />
                <a
                  href="tel:+8801914001234"
                  style={{
                    color: "#ffff",
                    textDecoration: "none",
                    textWrap: "nowrap",
                  }}
                >
                  Emergency:
                  <br className="d-lg-none" />
                  <span> +880-1914-001234</span>
                </a>
                <br className="d-lg-none" />
                <a
                  href="tel:02222262466"
                  style={{
                    color: "#ffff",
                    textDecoration: "none",
                    textWrap: "nowrap",
                  }}
                >
                  <span>
                    Appointment Hotline: <br className="d-lg-none" />{" "}
                    02-2222-62466
                  </span>
                </a>
                {/*<a rel="noopener noreferrer">
                  <img src="/assets/images/10666.png" alt="" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/images/facebook.png" alt="" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/images/instagram.png" alt="" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/images/twitter.png" alt="" />
                </a>
                <a href="#" target="_blank" rel="noopener noreferrer">
                  <img src="/assets/images/youtube.png" alt="" />
              </a>*/}
              </div>
              <div
                className="col-md-4 top-header"
                style={{
                  display: "flex",
                  rowGap: "20px",
                  columnGap: "20px",
                  justifyContent: "flex-end",
                }}
              >
                <a
                  style={{
                    textDecoration: "none",
                    textTransform: "capitalize",
                    fontSize: "14px",
                  }}
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/assets/images/Logo12.png" alt="" />
                </a>
                <img src="/assets/images/Line 1.png" alt="" />
                <a
                  style={{
                    textDecoration: "none",
                    textTransform: "capitalize",
                    fontSize: "14px",
                  }}
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/assets/images/Group1.png" alt="" />
                </a>
                <img src="/assets/images/Line 1.png" alt="" />
                <a
                  style={{ textDecoration: "none", fontSize: "14px" }}
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/assets/images/Group2.png" alt="" />
                </a>
                <img src="/assets/images/Line 1.png" alt="" />
                <a
                  style={{ textDecoration: "none", fontSize: "14px" }}
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/assets/images/Group3.png" alt="" />
                </a>
                <img src="/assets/images/Line 1.png" alt="" />
                <a
                  style={{ textDecoration: "none", fontSize: "14px" }}
                  href="#"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src="/assets/images/Group5.png" alt="" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <header
          className="header-part hrad subpages_header"
          id="doctor-profile"
        >
          {/*<div className="container">*/}

          <nav className="navbar ">
            <div className="container">
              <div className="row ">
                <div className="col-sm-6 col-12 images">
                  <a className="navbar-brand1" href="/">
                    <img
                      className="navbar-brand1 img-fluid"
                      src="/assets/images/united_logo.png"
                      alt="logo2"
                      width={50}
                      style={{ objectFit: "cover" }}
                    />
                  </a>
                  <a className="navbar-brand2" href="/">
                    <img
                      className="navbar-brand2"
                      src="/assets/images/logo.png"
                      alt="logo2"
                    />
                  </a>
                </div>
                <div className="">
                  {/*<input type="text" className="form-control" name="search_keywords" id="header_search_keywords" value={this.state.search_keywords} placeholder="Search..." onChange={this.handleChange} onClick={this.showSearchResult} onKeyUp={this.handleKeyUp} autoComplete="off" />

              <span style={{ cursor: "pointer" }} className="input-group-text" value={this.state.search_keywords} onClick={this.showSearchResult} id="basic-addon1"> <svg style={{ marginRight: "10px" }} xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" className="bi bi-search" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                  </svg></span>*/}
                </div>
              </div>

              <div>
                <ul className="big-screen t ">
                  {/* <li className="nav-item">
                  <a className="nav-link number" href="tel:10666"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" className="bi bi-telephone-forward" viewBox="0 0 16 16">
                    <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                  </svg> 10666</a>
                </li> */}
                  {this.state.menu.length > 0 ? (
                    this.state.menu.map((hmenu) => {
                      
                      return (
                        // <li className="nav-item customenavitem">
                        //   {hmenu.title === 'Book Appointment'
                        //     ?
                        //     <a className="nav-link active" href="#offcanvasExample" data-bs-toggle="offcanvas" role="button" aria-controls="offcanvasExample">Book Appointment</a>
                        //     :
                        //     <a href={WEBSITEPAGE_URL + hmenu.slug} className="nav-link">{hmenu.title}</a>
                        //   }
                        // </li>
                        <li className="">
                          {hmenu.title === "Book Appointment" && (
                            <div>
                              {!localStorage.getItem(USER_ID) &&
                              localStorage.getItem(USER_LOCAL_ID) ? (
                                <a
                                  className="nav-link active text-dark"
                                  data-bs-toggle="offcanvas"
                                  role="button"
                                  href="#offcanvasExample5"
                                  aria-controls="offcanvasExample5"
                                  onClick={this.handleOpenPatientRegisterPopUp}
                                >
                                  Book Appointment
                                </a>
                              ) : (
                                <a
                                  className="nav-link active text-dark"
                                  href="#offcanvasExample"
                                  data-bs-toggle="offcanvas"
                                  role="button"
                                  aria-controls="offcanvasExample"
                                >
                                  Book Appointment
                                </a>
                              )}
                            </div>
                          )}
                          {hmenu.title === "Emergency" && (
                            <a
                              className="nav-link"
                              href={WEBSITEPAGE_URL + hmenu.slug}
                            >
                              Emergency
                            </a>
                          )}
                          {/* {
                          hmenu.title!===hmenu.title=== 'Book Appointment'?<img src="/assets/images/new-logo.png" alt="" />:""
                        } */}
                        </li>
                      );
                    })
                  ) : (
                    <li></li>
                  )}
                  <li>
                    <Link className="nav-link d-none" to="/cart">
                      <div
                        style={{
                          position: "relative",
                          display: "none",
                        }}
                      >
                        <MyContext.Consumer>
                          {(context) => {
                            const { totalQuantity } = context;
                            return (
                              <span
                                className="badge rounded-circle d-flex justify-content-center align-items-center"
                                style={{
                                  position: "absolute",
                                  top: -15,
                                  right: -10,
                                  height: "20px",
                                  width: "20px",
                                  border: "2px solid #292D32",
                                  textAlign: "center",
                                  padding: "5px",
                                  color: "black",
                                }}
                              >
                                {cart && totalQuantity}
                              </span>
                            );
                          }}
                        </MyContext.Consumer>
                        {/* <span
                          className="badge rounded-circle d-flex justify-content-center align-items-center"
                          style={{
                            position: "absolute",
                            top: -15,
                            right: -10,
                            height: "20px",
                            width: "20px",
                            border: "2px solid #292D32",
                            textAlign: "center",
                            padding: "5px",
                            color: "black",
                          }}
                        >
                          {cart && cart}
                        </span> */}
                        <img
                          src="/assets/images/shopping-cart.png"
                          alt="logo2"
                        />
                      </div>
                      {/* <img src="/assets/images/shopping-cart.png" alt="logo2" /> */}
                    </Link>
                  </li>
                  <li>
                    {
                      localStorage.getItem(USER_LOCAL_ID) ? (
                        // <p className='customHoverP pad'><a href="/logout">Logout</a></p>
                        <div className="dropdown">
                          <a
                            className=" dropdown-toggle dropdownMenu nav-link"
                            type="button"
                            id="dropdownMenuButton"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                          >
                            {UserName}
                          </a>
                          <div
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton"
                          >
                            {patient_user_id ? (
                              <Fragment>
                                <a
                                  className="dropdown-item btn disabled"
                                  href="/patient-protal"
                                >
                                  Patient ID: {patient_user_id}
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="/patient-protal"
                                >
                                  My Portal
                                </a>
                                <a
                                  className="dropdown-item"
                                  href="/pages/patientbillhistory"
                                >
                                  Bill History
                                </a>
                              </Fragment>
                            ) : null}
                            {!patient_user_id ? (
                              <a
                                className="dropdown-item"
                                data-bs-toggle="offcanvas"
                                href="#offcanvasExample5"
                                role="button"
                                aria-controls="offcanvasExample5"
                                onClick={this.handleOpenPatientRegisterPopUp}
                                data-bs-dismiss="offcanvas"
                              >
                                Patient Registration
                              </a>
                            ) : null}
                            {this.state.menu.length > 0 ? (
                              this.state.menu
                                .filter((hmenu) =>
                                  [
                                    "Packages",
                                    "Departments",
                                    "Services",
                                  ].includes(hmenu.title)
                                )
                                .map((hmenu) => (
                                  <a
                                    className="dropdown-item"
                                    href={WEBSITEPAGE_URL + hmenu.slug}
                                    key={hmenu.title}
                                  >
                                    {hmenu.title}
                                  </a>
                                ))
                            ) : (
                              <li></li>
                            )}
                            <a className="dropdown-item" href="/logout">
                              Logout
                            </a>
                          </div>
                        </div>
                      ) : (
                        <li className="d-flex align-items-center">
                          {/* <a href="#"><img src="/assets/images/shopping-cart.png" alt="logo2" /></a> */}
                          <div className="dropdown">
                            <a
                              className=" dropdown-toggle dropdownMenu"
                              type="button"
                              id="dropdownMenuButton"
                              data-toggle="dropdown"
                              aria-haspopup="true"
                              aria-expanded="false"
                            >
                              <img src="/assets/images/User.png" alt="logo2" />
                            </a>
                            <div
                              className="dropdown-menu"
                              aria-labelledby="dropdownMenuButton"
                            >
                              <a
                                className="dropdown-item"
                                // href="#"
                                // data-bs-toggle="modal"
                                // data-bs-target="#loginModal"

                                href="#offcanvasExample"
                                data-bs-toggle="offcanvas"
                                role="button"
                                aria-controls="offcanvasExample"
                              >
                                Login/Sign up
                              </a>

                              {this.state.menu.length > 0 ? (
                                this.state.menu
                                  .filter((hmenu) =>
                                    [
                                      "Packages",
                                      "Departments",
                                      "Services",
                                    ].includes(hmenu.title)
                                  )
                                  .map((hmenu) => (
                                    <a
                                      className="dropdown-item"
                                      href={WEBSITEPAGE_URL + hmenu.slug}
                                      key={hmenu.title}
                                    >
                                      {hmenu.title}
                                    </a>
                                  ))
                              ) : (
                                <p></p>
                              )}
                            </div>
                          </div>
                        </li>
                      )
                      // <p className="pad"  >
                      //   <a className="users"
                      //     // style={{ paddingTop: "25px", textDecoration: "none", paddingLeft: "10px", backgroundColor: "red" }}
                      //     href="#offcanvasExample"
                      //     data-bs-toggle="offcanvas"
                      //     role="button"
                      //     aria-controls="offcanvasExample"
                      //   >
                      //     Login / Signup
                      //   </a>{" "}
                      // </p>
                    }
                  </li>
                </ul>
                <div className="soto-screen">
                  <CollapsibleButton
                    content={
                      <ul className="buttonUL t">
                        <li className="nav-item text-light">
                          <a
                            className="nav-link  text-light number "
                            href="tel:10666"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="currentColor"
                              className="bi bi-telephone-forward"
                              viewBox="0 0 16 16"
                            >
                              <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.568 17.568 0 0 0 4.168 6.608 17.569 17.569 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.678.678 0 0 0-.58-.122l-2.19.547a1.745 1.745 0 0 1-1.657-.459L5.482 8.062a1.745 1.745 0 0 1-.46-1.657l.548-2.19a.678.678 0 0 0-.122-.58L3.654 1.328zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511zm10.762.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708z" />
                            </svg>{" "}
                            10666
                          </a>
                        </li>
                        {this.state.menu.length > 0 ? (
                          this.state.menu.map((hmenu) => {
                            return (
                              <li className="nav-item text-light">
                                {hmenu.title === "Book Appointment" ? (
                                  <div>
                                    <div>
                                      {!localStorage.getItem(USER_ID) &&
                                      localStorage.getItem(USER_LOCAL_ID) ? (
                                        <a
                                          className="nav-link active text-dark"
                                          data-bs-toggle="offcanvas"
                                          role="button"
                                          href="#offcanvasExample5"
                                          aria-controls="offcanvasExample5"
                                          onClick={
                                            this.handleOpenPatientRegisterPopUp
                                          }
                                        >
                                          Book Appointment
                                        </a>
                                      ) : (
                                        <a
                                          className="nav-link active text-dark"
                                          href="#offcanvasExample"
                                          data-bs-toggle="offcanvas"
                                          role="button"
                                          aria-controls="offcanvasExample"
                                        >
                                          Book Appointment
                                        </a>
                                      )}
                                    </div>
                                    {/* <a
                                      className="nav-link active text-dark"
                                      href="#offcanvasExample"
                                      data-bs-toggle="offcanvas"
                                      role="button"
                                      aria-controls="offcanvasExample"
                                    >
                                      Book Appointment
                                    </a> */}
                                    <Link
                                      className="nav-link d-none"
                                      to="/cart"
                                    >
                                      <div
                                        style={{
                                          position: "relative",
                                        }}
                                      >
                                        <MyContext.Consumer>
                                          {(context) => {
                                            const { totalQuantity } = context;
                                            return (
                                              <span
                                                className="badge rounded-circle d-flex justify-content-center align-items-center"
                                                style={{
                                                  position: "absolute",
                                                  top: -15,
                                                  left: 15,
                                                  height: "20px",
                                                  width: "20px",
                                                  border: "2px solid #292D32",
                                                  textAlign: "center",
                                                  padding: "5px",
                                                  color: "black",
                                                }}
                                              >
                                                {cart && totalQuantity}
                                              </span>
                                            );
                                          }}
                                        </MyContext.Consumer>
                                        {/* <span
                          className="badge rounded-circle d-flex justify-content-center align-items-center"
                          style={{
                            position: "absolute",
                            top: -15,
                            right: -10,
                            height: "20px",
                            width: "20px",
                            border: "2px solid #292D32",
                            textAlign: "center",
                            padding: "5px",
                            color: "black",
                          }}
                        >
                          {cart && cart}
                        </span> */}
                                        <img
                                          src="/assets/images/shopping-cart.png"
                                          alt="logo2"
                                        />
                                      </div>
                                      {/* <img src="/assets/images/shopping-cart.png" alt="logo2" /> */}
                                    </Link>
                                  </div>
                                ) : (
                                  <a
                                    href={WEBSITEPAGE_URL + hmenu.slug}
                                    className="nav-link"
                                  >
                                    {hmenu.title}
                                  </a>
                                )}
                              </li>
                            );
                          })
                        ) : (
                          <li></li>
                        )}
                        <li className="nav-item" style={{ marginLeft: "1rem" }}>
                          {localStorage.getItem(USER_ID) ? (
                            <div className="dropdown">
                              <a
                                className=" dropdown-toggle dropdownMenu"
                                type="button"
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                {UserName}
                              </a>
                              <div
                                className="dropdown-menu"
                                aria-labelledby="dropdownMenuButton"
                              >
                                {patient_user_id ? (
                                  <Fragment>
                                    <a
                                      className="dropdown-item btn disabled"
                                      href="/patient-protal"
                                    >
                                      Patient ID: {patient_user_id}
                                    </a>
                                    <a
                                      className="dropdown-item"
                                      href="/patient-protal"
                                    >
                                      My Portal
                                    </a>
                                    <a
                                      className="dropdown-item"
                                      href="/pages/patientbillhistory"
                                    >
                                      Bill History
                                    </a>
                                  </Fragment>
                                ) : null}
                                <a className="dropdown-item" href="/logout">
                                  Logout
                                </a>
                              </div>
                            </div>
                          ) : (
                            <p className="pad ">
                              <a
                                className="users"
                                style={{
                                  textDecoration: "none",
                                  paddingLeft: "10px",
                                }}
                                href="#loginModal"
                                data-bs-toggle="modal"
                                data-bs-target="#exampleModal"
                                role="button"
                                aria-controls="offcanvasExample"
                              >
                                Login / Signup
                              </a>{" "}
                            </p>
                          )}
                        </li>
                      </ul>
                    }
                  />
                </div>
              </div>
            </div>
          </nav>
          <div className="row">
            <div className="col-sm-1"></div>
            <div className="col-sm-6">
              <div className="search-popup-main" style={{ width: "100%" }}>
                <div
                  className="search-popupp"
                  style={{
                    display: "none",
                    overflowY: "scroll",
                    height: "424px",
                    zIndex: "99999",
                  }}
                >
                  <h4>Specialists</h4>
                  <hr className="lists-line" />
                  <div className="row mt-4">
                    {this.state.default_doctors.length > 0 ? (
                      this.state.default_doctors.map(
                        (default_search_doctor) => {
                          let doctor_name = default_search_doctor.doctor_name;
                          let new_doctor_name = doctor_name.replaceAll(
                            " ",
                            "-"
                          );
                          return (
                            <div className="col-lg-4 col-md-12 mt-4">
                              <div className="doctor-list">
                                <a
                                  href={
                                    SITE_URL +
                                    "/consultant/" +
                                    default_search_doctor.slug
                                  }
                                  style={{
                                    textDecoration: "none",
                                    color: "#212529",
                                  }}
                                >
                                  <div className="row">
                                    <div className="col-5">
                                      {default_search_doctor.doctor_profile ? (
                                        <img
                                          src={
                                            IMAGE_URL +
                                            "/DoctorProfileImg/" +
                                            default_search_doctor.doctor_profile
                                          }
                                          alt="Bitmap-3"
                                          style={{
                                            height: "120px",
                                            width: "100%",
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                                          alt="Bitmap-3"
                                          style={{
                                            height: "120px",
                                            width: "100%",
                                          }}
                                        />
                                      )}
                                    </div>
                                    <div className="col-7">
                                      <h6 style={{ fontSize: "14px" }}>
                                        {default_search_doctor.doctor_name}
                                      </h6>
                                      <p style={{ fontSize: "12px" }}>
                                        {default_search_doctor.degree}
                                      </p>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          );
                        }
                      )
                    ) : (
                      <div className="col-lg-12 col-md-12">
                        <div className="doctor-list">
                          <div className="row">
                            <p style={{ fontSize: "12px" }}>no result found</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <br />
                  <br />
                  <h5>Packages</h5>
                  <hr className="lists-line" />
                  <div className="row mt-4">
                    {this.state.default_packages.length > 0 ? (
                      this.state.default_packages.map(
                        (default_search_packages) => {
                          let package_name = default_search_packages.name;
                          let new_package_name = package_name.replaceAll(
                            " ",
                            "-"
                          );
                          return (
                            <div className="col-lg-4 col-sm-12">
                              <div className="Package-part">
                                <a
                                  href={
                                    SITE_URL + "/packages/" + new_package_name
                                  }
                                  style={{
                                    textDecoration: "none",
                                    color: "#212529",
                                  }}
                                >
                                  <div className="row">
                                    <div className="col-4 sp-0-search">
                                      <img
                                        src={icons_rotate}
                                        alt="icons-rotate"
                                      />
                                    </div>
                                    <div className="col-8 sp-0-search bg-color-gry">
                                      <h6 style={{ fontSize: "16px" }}>
                                        {default_search_packages.name}
                                      </h6>
                                      <p
                                        title={
                                          default_search_packages.description
                                        }
                                        dangerouslySetInnerHTML={{
                                          __html:
                                            default_search_packages.description
                                              ? default_search_packages.description.substr(
                                                  0,
                                                  140
                                                )
                                              : "",
                                        }}
                                      ></p>
                                    </div>
                                  </div>
                                </a>
                              </div>
                            </div>
                          );
                        }
                      )
                    ) : (
                      <div className="col-lg-12 col-sm-12">
                        <div className="Package-part">
                          <div className="row">
                            <p>No packages found</p>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <br />
                  <br />
                  <h5>Blog</h5>
                  <hr className="lists-line" />
                  <div className="row">
                    {this.state.default_publications.length > 0 ? (
                      this.state.default_publications.map(
                        (default_search_publications) => {
                          let publications_title =
                            default_search_publications.publications_title;
                          let new_publications_title =
                            publications_title.replaceAll(" ", "-");
                          return (
                            <div className="col-sm-6">
                              <a
                                href={
                                  SITE_URL +
                                  "/publications/" +
                                  new_publications_title +
                                  "~" +
                                  default_search_publications.id
                                }
                                style={{
                                  textDecoration: "none",
                                  color: "#212529",
                                }}
                              >
                                <h6
                                  className="colo-dark"
                                  title={
                                    default_search_publications.publications_title
                                  }
                                >
                                  {default_search_publications.publications_title.substr(
                                    0,
                                    40
                                  )}
                                </h6>
                              </a>
                              <p
                                style={{ fontSize: "14px" }}
                                dangerouslySetInnerHTML={{
                                  __html:
                                    default_search_publications.publications_desc
                                      ? default_search_publications.publications_desc.substr(
                                          0,
                                          150
                                        )
                                      : "",
                                }}
                              ></p>
                            </div>
                          );
                        }
                      )
                    ) : (
                      <div className="col-sm-12">
                        <p className="pera-search">No any blog found</p>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-5"></div>
          </div>
          {/* <PatientRegisterPopup></PatientRegisterPopup> */}
          {step_html}
          {/*</div>*/}
        </header>
        {this.state.patientRegPopup ? (
          <PatientRegisterPopup showpopup={this.state.showPatientRegPopup} />
        ) : null}
        {/* <PatientRegisterPopup/> */}
      </div>
    );
  }
}
export default HeaderHome;



// WEBPACK FOOTER //
// ./src/component/frontend/HeaderHome.js